
import PageTitleArea from '~/components/common/section/PageTitleArea.vue'
import SkeletonBox from '@/components/common/SkeletonBox.vue'
import SwiperWrap from '~/components/ds/common/SwiperCmp.vue'

export default {
  components: {
    PageTitleArea,
    SwiperWrap,
    SkeletonBox,
  }
}
